/**
 * Mapbox access token.
 *
 * TEMPORARY: for local dev the token is read from `VITE_MAPBOX_TOKEN`
 * (see `.env.local`). If you'd rather not use an env var, paste the token
 * into `HARDCODED_DEV_TOKEN` below.
 *
 * TODO(secrets): replace this with the runtime fetch used by the `place`
 * repo — `place/frontendSecrets` → `mapBoxToken`, via a Cognito Identity
 * Pool credential provider + AWS Secrets Manager. That needs the identity
 * pool + IAM read permission wired first.
 */

// ← paste your Mapbox token here for local dev if you prefer not to use .env
const HARDCODED_DEV_TOKEN = 'pk.eyJ1IjoibGFmYXlldHRlc3F1YXJlIiwiYSI6ImNsbmtpaGx3cjAybnIybXJxOTI3cHB5N2wifQ.bhOEDp1gdaSACNDYHAteRQ';

export const MAPBOX_TOKEN: string =
  (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined) || HARDCODED_DEV_TOKEN;

/** The clean, label-free light basemap used across the impact map (matches
 *  the Figma). Carto's positron style needs no Mapbox style token. */
export const MAP_BASE_STYLE =
  'https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json';
